import React, { useContext, useEffect, useState } from 'react';
import axiosInstance from '../../utils/axiosInstance';
import SingleItemCarousel from '../components/SingleItemCarousel';
import ArticleCard from '../components/ArticleCard';
import TopViewedSidebar from '../components/TopViewedSidebar';
import BreakingNews from '../components/BreakingNews';
import Pagination from '../components/Pagination';
import { AuthContext } from '../../context/AuthContext';

const Home = () => {
   const { loadingHandle } = useContext(AuthContext);

  const [blogs, setBlogs] = useState([]);
 const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(20);
  // Pagination Logic
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = blogs.slice(indexOfFirstPost, indexOfLastPost);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const { data } = await axiosInstance.get(`/blogs`);
        setBlogs(data);
      } catch (error) {
        console.error('Error fetching blogs', error);
      }
    };
    loadingHandle(true)
    fetchBlogs();
    loadingHandle(false)
  }, []);


  return (
    <div>
      <SingleItemCarousel />
      {/* <HeroText/> */}
      {/* <CanvasGradient3DText/> */}
      <BreakingNews/>
      {/* --- NEW TWO-COLUMN LAYOUT --- */}
      <div className="container mx-auto p-6">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
         {/* Left Column (3/4 width) */}
          <main className="lg:col-span-3">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {currentPosts && currentPosts.map((blog) => (
                <ArticleCard key={blog.id} blog={blog} />
              ))}
            </div>
             <Pagination
                postsPerPage={postsPerPage}
                totalPosts={blogs.length}
                paginate={paginate}
                currentPage={currentPage}
            />
          </main>
          
          {/* Right Column (1/4 width) */}
          <aside className="lg:col-span-1">
            <TopViewedSidebar />
          </aside>

        </div>
      </div>
    </div>
  );
};

export default Home;